import { VehicleRegistrationFormat } from '../inputs'
import { findBestMatch } from './string'

export const isValidVRN = ({
  regex,
  regexBlacklist,
}: Pick<VehicleRegistrationFormat, 'regex' | 'regexBlacklist'>) => {
  const valid = new RegExp(regex)
  const blacklist = regexBlacklist ? new RegExp(regexBlacklist) : undefined

  return (vrn = ''): boolean => valid.test(vrn) && !blacklist?.test(vrn)
}

export const formatPartialLicencePlate = ({
  divider,
  regexFormat,
  regexIncomplete,
}: Pick<VehicleRegistrationFormat, 'divider' | 'regexFormat' | 'regexIncomplete'>) => {
  const formats = regexFormat.map((regex) => new RegExp(regex))
  const incomplete = new RegExp(regexIncomplete)

  return (licencePlate: string): string => {
    const upperCasePlate = licencePlate.replace(/\s|-/g, '').toUpperCase()
    const bestMatch = findBestMatch(upperCasePlate, formats)

    return bestMatch
      ? bestMatch.slice(1).reduce((acc, next) => `${acc}${divider}${next}`)
      : sanitiseInitialInput(upperCasePlate, incomplete, divider)
  }
}

const sanitiseInitialInput = (input: string, regexIncomplete: RegExp, divider: string) =>
  regexIncomplete
    .exec(input)
    ?.slice(1)
    .filter(Boolean)
    .reduce((acc, next) => `${acc}${divider}${next}`) ?? ''
